<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 3.125V21.0938M12.5 21.0938C10.9667 21.0938 9.49781 21.3698 8.14044 21.875M12.5 21.0938C14.0333 21.0938 15.5022 21.3698 16.8596 21.875M19.5312 5.17801C17.2339 4.8547 14.8865 4.6875 12.5 4.6875C10.1135 4.6875 7.76607 4.8547 5.46875 5.17801M19.5312 5.17801C20.5838 5.32614 21.6258 5.50705 22.6562 5.71966M19.5312 5.17801L22.2608 16.3501C22.3877 16.8696 22.1502 17.4205 21.647 17.6015C20.9863 17.8392 20.2739 17.9688 19.5312 17.9688C18.7886 17.9688 18.0762 17.8392 17.4155 17.6015C16.9123 17.4205 16.6748 16.8696 16.8017 16.3501L19.5312 5.17801ZM2.34375 5.71966C3.37418 5.50705 4.41621 5.32614 5.46875 5.17801M5.46875 5.17801L8.1983 16.3501C8.32521 16.8696 8.0877 17.4205 7.58452 17.6015C6.92375 17.8392 6.21138 17.9688 5.46875 17.9688C4.72612 17.9688 4.01375 17.8392 3.35298 17.6015C2.8498 17.4205 2.61229 16.8696 2.7392 16.3501L5.46875 5.17801Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgScale',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
